import { z } from 'zod'
import { oc } from '@orpc/contract'

export const scribeJoinClaimResponseSchema = z.object({
  claimed: z.literal(true),
})
export type ScribeJoinClaimResponse = z.infer<typeof scribeJoinClaimResponseSchema>

export const scribeJoinReleaseResponseSchema = z.object({
  released: z.boolean(),
})
export type ScribeJoinReleaseResponse = z.infer<typeof scribeJoinReleaseResponseSchema>

/** Opaque per-tab id minted by the client; bounded, not format-locked. */
const tabId = z.string().min(1).max(64)

export const scribeJoinClaim = oc
  .route({ method: 'POST', path: '/v2/scribe/sessions/{encounterId}/join-claim' })
  .input(
    z.object({
      encounterId: z.string(),
      tabId,
      /** Resume path ONLY — overwrites a dead tab's still-live claim. */
      takeover: z.boolean().optional(),
    }),
  )
  .output(scribeJoinClaimResponseSchema)

export const scribeJoinRelease = oc
  .route({ method: 'POST', path: '/v2/scribe/sessions/{encounterId}/join-release' })
  .input(z.object({ encounterId: z.string(), tabId }))
  .output(scribeJoinReleaseResponseSchema)
